import { BtnBack } from "../../../../components/button/button-back";
import { BtnSubmit } from "../../../../components/button/button-submit/button-submit";
import TextInput from "../../../../components/inputs/text";
import SelectInput from "../../../../components/inputs/select";
import Loading from "../../../../components/loading";
import AlertMessage from "../../../../components/alert-message";
import libForm from "../../../../util/libForm";
import { IndexHook } from "./hooks";

const Form = ({
	isOpenModalRegister,
	ident,
	idTable,
	selectedData,
	setSelectData,
	fetchID,
	reloadData,
	insert,
}) => {
	const {
		register,
		control,
		errors,
		isSubmitting,
		handleSubmit,
		handleOnSubmit,
		handleCloseModalRegister,
		loading,
	} = IndexHook({
		isOpenModalRegister,
		ident,
		idTable,
		selectedData,
		setSelectData,
		fetchID,
		reloadData,
		insert,
	});

	return (
		<>
			{loading ? (
				<div className="flex h-full">
					<Loading mensagem="Carregando..." />
				</div>
			) : (
				<form
					className="form"
					onSubmit={handleSubmit(handleOnSubmit)}
				>
					<main className="overflow-auto">
						<div className="row">
							<TextInput
								label="Data de Início"
								id="data_inicio"
								name="data_inicio"
								type="datetime-local"
								register={register}
								errors={errors}
								required={true}
								className="col-12 col-md-6"
								onKeyDown={libForm.EnterTab}
								autoFocus={true}
							/>

							<TextInput
								label="Data de Fim"
								id="data_fim"
								name="data_fim"
								type="datetime-local"
								register={register}
								errors={errors}
								required={true}
								className="col-12 col-md-6"
								onKeyDown={libForm.EnterTab}
							/>

							<TextInput
								label="Motivo da Pausa"
								id="motivo"
								name="motivo"
								register={register}
								errors={errors}
								placeholder="Férias, Feriado, Reforma..."
								required={true}
								className="col-12"
								onKeyDown={libForm.EnterTab}
							/>

							<SelectInput
								label="Tipo / Modalidade"
								id="tipo"
								labelSelect="descricao"
								data={[
									{ tipo: "LOJA", descricao: "Loja" },
									{ tipo: "DELIVERY", descricao: "Delivery" },
									{ tipo: "AMBOS", descricao: "Ambos" },
								]}
								control={control}
								errors={errors}
								required={true}
								className="col-12 col-md-6"
								onKeyDown={libForm.EnterTab}
							/>

							<div className={`check-box col-12 col-sm-12`}>
								<div className="check-input">
									<input
										className={`${errors.ativo ? "error" : ""}`}
										id="ativo_pausa"
										type="checkbox"
										{...register("ativo")}
										autoComplete="off"
									/>
									<label htmlFor="ativo_pausa">
										<span className="text-lg">Pausa ativa</span>
									</label>
								</div>
							</div>
						</div>
						
						<AlertMessage type="warning">
							Ao definir uma pausa, a vitrine ou portal respeitará esta exceção de horário ignorando a tabela normal de funcionamento!
						</AlertMessage>
					</main>

					<div className="flex justify-between flex-row-reverse p-1 mt-3">
						<BtnSubmit text="Salvar" isSubmitting={isSubmitting} />
						<BtnBack onClick={() => handleCloseModalRegister()} isSubmitting={isSubmitting} />
					</div>
				</form>
			)}
		</>
	);
};

export default Form;
